import React, { useContext, useEffect, useState } from "react";
import { debug, sortObjectsByAlphabet } from "../utils";
import { connect } from "react-redux";
import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";
import * as deviceService from "../devices/deviceService";
import { TableContext } from "../index";
import Select from 'react-select';

function ChooseDeviceField() {

    const history = useHistory();
    const [selectedDeviceId, setSelectedDeviceId] = useState('all');
    const [devicesList, setDevicesList] = useState([]);
    const { config, setConfig } = useContext(TableContext);


    useEffect(() => {
        getDeviceList();
        /* eslint-disable react-hooks/exhaustive-deps */
                // if (selectedType) {
        //     if (selectedType !== 'all') {
        //         deviceService.loadByDeviceTypeId(selectedType);
        //     }
        // } else {
        //     const filters = getFilers(true);
        //     if (filters.device) {
        //         history.push({
        //             pathname: history.pathname,
        //             search: urlService.removeFilter('device')
        //         })
        //     }
        // }
    }, [])

    const getDeviceList = async () => {
        const devices = await deviceService.list();
        setDevicesList(devices);
    }


    const onChange = (selectedOption) => {
        const id = selectedOption.value;
        setSelectedDeviceId(id);
        setConfig({ ...config, deviceId: id });

        if (id === 'all') {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            })
            return;
        }

        const device = devicesList.find(device => device.id === Number(id));
        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('device', device.hostName)
        })
    }

    const devicesCopy = sortObjectsByAlphabet(devicesList, 'hostName');

    const options = [
        { value: 'all', label: 'All' },
        ...devicesCopy.map(device => ({ value: String(device.id), label: device.hostName }))
    ];

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === String(selectedDeviceId)) || options[0]}
            onChange={onChange}
            options={options}
            isSearchable={true}
            placeholder="All"
        />
    );
}


function mapStateToProps(state) {
    debug("DeviceTypeField mapStateToProps", state);
    const recentViolationsPage = state.recentViolationsPage;
    return {
        devices: recentViolationsPage.devices
    };
}

export default connect(mapStateToProps)(ChooseDeviceField);
